import React from "react";
import RestaurantTemplate from "./actualTemplates/RestaurantTemplate";
import TechStartupTemplate from "./actualTemplates/TechStartupTemplate";
import ArtistPortfolioTemplate from "./actualTemplates/ArtistPortfolioTemplate";

const TemplatePreviewWrapper = ({
  componentName,
  brandName,
  tagline,
  logo,
  colorTheme,
}) => {
  const componentMap = {
    RestaurantTemplate,
    TechStartupTemplate,
    ArtistPortfolioTemplate,
  };

  const Component = componentMap[componentName];

  if (!Component) return <div>Template coming soon...</div>;

  return (
    <Component
      brandName={brandName}
      tagline={tagline}
      logo={logo}
      colorTheme={colorTheme}
    />
  );
};

export default TemplatePreviewWrapper;
